// extracted by mini-css-extract-plugin
export default {"form":"modalTodaysCode_form__YRj57","inputMask":"modalTodaysCode_inputMask__hX0wX","inputMaskLetterSpacing":"modalTodaysCode_inputMaskLetterSpacing__K+G73"};